import { useCallback } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { thirdPartyAgreementKeys } from './thirdPartyAgreementKeys';

export type ThirdPartyInvoiceNotice =
    | { kind: 'submitted'; invoiceNumber: string }
    | { kind: 'rejected' }
    | { kind: 'unconfirmed' }
    | { kind: 'not-found' };

interface InvoiceNoticeStore {
    notice: ThirdPartyInvoiceNotice | null;
    writeNotice: (notice: ThirdPartyInvoiceNotice | null) => void;
}

// Cached per visit, so an outcome settling while the tab is unmounted still shows, but never on a later visit.
export function useThirdPartyInvoiceNotice(vrm: string, reference: string, visit: string): InvoiceNoticeStore {
    const queryClient = useQueryClient();
    const { data } = useQuery<ThirdPartyInvoiceNotice | null>({
        queryKey: thirdPartyAgreementKeys.invoiceNotice(vrm, reference, visit),
        queryFn: () => null,
        enabled: false,
        staleTime: Infinity,
        gcTime: Infinity,
    });

    const writeNotice = useCallback(
        (notice: ThirdPartyInvoiceNotice | null): void => {
            queryClient.setQueryData(thirdPartyAgreementKeys.invoiceNotice(vrm, reference, visit), notice);
        },
        [queryClient, vrm, reference, visit],
    );

    return { notice: data ?? null, writeNotice };
}
